<template>
  <div class="appCenter">
    <appManagement v-show="showCard === 0" ref="appManagementRef" @changeShowCard="changeShowCard"/>
		<workSpace v-show="showCard === 1" ref="workSpaceRef" @changeShowCard="changeShowCard"/>
  </div>
</template>

<script>
import appManagement from './views/appManagement.vue';
import workSpace from './views/workSpace.vue';
export default {
  components: {
		appManagement,
		workSpace
  },

  data() {
		return{
			showCard:0,//0 应用中心  1：工作空间
		}
  },
	methods: {
		changeShowCard(newValue){
			this.showCard = newValue;
		}
	},
};
</script>

<style scoped>
.appCenter {
  width: 100vw;
  height: 100vh;
  background-color: #f2f4f7;
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/appStore/index.vue